/**
 * AF hero carousel
 * Namespace: window.AfHero
 *
 * Modified: 2026-08-11
 * Author: Cursor Agent
 * Reason: Remove CTA sync — sticky CTA is page-level on mobile
 * Modified: 2026-08-11 17:02 IST — Dots live in mobile chrome; selectors unchanged
 * Modified: 2026-08-14 18:12 IST — Desktop side arrows to toggle hero slides
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-af-hero]';

  function initHero(root) {
    if (!root || root.getAttribute('data-af-ready') === '1') return;

    var track = root.querySelector('[data-af-hero-track]');
    var slides = root.querySelectorAll('[data-af-hero-slide]');
    var dots = root.querySelectorAll('[data-af-hero-dot]');
    var viewport = root.querySelector('[data-af-hero-viewport]');

    if (!track || !slides.length) return;

    root.setAttribute('data-af-ready', '1');

    var index = 0;
    var count = slides.length;
    var autoplay = root.getAttribute('data-af-autoplay') === 'true';
    var intervalMs = parseInt(root.getAttribute('data-af-interval'), 10) || 5000;
    var timer = null;
    var touchStartX = 0;
    var touchDeltaX = 0;
    var arrows = null;

    function syncArrows() {
      if (!arrows) return;
      arrows.setEnabled(count > 1);
      arrows.setDisabled(index <= 0, index >= count - 1);
    }

    function goTo(nextIndex) {
      if (count < 1) return;
      index = Math.max(0, Math.min(count - 1, nextIndex));
      track.style.transform = 'translate3d(' + -index * 100 + '%, 0, 0)';

      Array.prototype.forEach.call(slides, function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      Array.prototype.forEach.call(dots, function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      syncArrows();
    }

    function next() {
      if (index >= count - 1) {
        stopAutoplay();
        return;
      }
      goTo(index + 1);
    }

    function prev() {
      if (index <= 0) return;
      goTo(index - 1);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || count < 2) return;
      timer = window.setInterval(next, intervalMs);
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-af-index'), 10);
        if (isNaN(i)) return;
        goTo(i);
        startAutoplay();
      });
    });

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.changedTouches || !e.changedTouches[0]) return;
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
          stopAutoplay();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!e.changedTouches || !e.changedTouches[0]) return;
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDeltaX) > 40) {
            if (touchDeltaX < 0) next();
            else prev();
          }
          startAutoplay();
        },
        { passive: true }
      );
    }

    /*
     * Modified: 2026-08-14 18:12 IST
     * Author: Cursor Agent
     * Reason: Desktop center-left/right arrows — cycle hero slides
     */
    if (window.AfArrowNav && typeof window.AfArrowNav.create === 'function' && count > 1) {
      arrows = window.AfArrowNav.create(root, {
        prevLabel: 'Previous slide',
        nextLabel: 'Next slide',
        onPrev: function () {
          stopAutoplay();
          prev();
          startAutoplay();
        },
        onNext: function () {
          stopAutoplay();
          next();
          startAutoplay();
        }
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initHero);
  }

  window.AfHero = {
    init: initAll,
    initOne: initHero
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root =
      event.target.querySelector(ROOT_SEL) ||
      (event.target.matches && event.target.matches(ROOT_SEL) ? event.target : null);
    if (root) {
      root.removeAttribute('data-af-ready');
      initHero(root);
    }
  });
})();
